"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function mnx(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1473 20.2395C6.99 19.8038 3.75 16.281 3.75 12C3.75 7.719 6.99 4.19625 11.1473 3.7605V6.288C9.78343 6.49821 8.53997 7.18983 7.64201 8.23761C6.74405 9.28539 6.25095 10.6201 6.252 12C6.25095 13.3799 6.74405 14.7146 7.64201 15.7624C8.53997 16.8102 9.78343 17.5018 11.1473 17.712V20.2395ZM12.7785 3.75C16.701 4.10925 19.8307 7.21275 20.2395 11.1277H17.7172C17.5296 9.89328 16.9469 8.75288 16.0565 7.87749C15.1661 7.0021 14.016 6.43888 12.7785 6.27225V3.75ZM20.25 12.7628C19.8885 16.7303 16.737 19.8878 12.7785 20.25V17.7277C14.0348 17.5586 15.2005 16.9809 16.0959 16.0836C16.9913 15.1863 17.5665 14.0194 17.733 12.7628H20.25Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1473 20.2395C6.99 19.8038 3.75 16.281 3.75 12C3.75 7.719 6.99 4.19625 11.1473 3.7605V6.288C9.78343 6.49821 8.53997 7.18983 7.64201 8.23761C6.74405 9.28539 6.25095 10.6201 6.252 12C6.25095 13.3799 6.74405 14.7146 7.64201 15.7624C8.53997 16.8102 9.78343 17.5018 11.1473 17.712V20.2395ZM12.7785 3.75C16.701 4.10925 19.8307 7.21275 20.2395 11.1277H17.7172C17.5296 9.89328 16.9469 8.75288 16.0565 7.87749C15.1661 7.0021 14.016 6.43888 12.7785 6.27225V3.75ZM20.25 12.7628C19.8885 16.7303 16.737 19.8878 12.7785 20.25V17.7277C14.0348 17.5586 15.2005 16.9809 16.0959 16.0836C16.9913 15.1863 17.5665 14.0194 17.733 12.7628H20.25Z", fill: color }));
}
exports["default"] = mnx;
//# sourceMappingURL=mnx.js.map